import React from 'react';
import { Loader2, Plus, X, Edit3, Copy, Trash2, Mail } from 'lucide-react';

export const TemplateManagerModal = ({ open, templates, loading, onClose, onCreateNew, onEdit, onDelete }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-40 p-4" data-testid="template-manager-modal">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-2xl max-h-[80vh] flex flex-col">
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
          <h2 className="text-base font-bold text-[#0A1F44]">Email Sequence Templates</h2>
          <div className="flex items-center gap-2">
            <button onClick={onCreateNew}
              className="flex items-center gap-1 px-3 py-1.5 bg-[#D4AF37] text-[#0A1F44] text-xs font-semibold rounded-lg hover:bg-[#c5a030]"
              data-testid="create-template-btn">
              <Plus className="h-3 w-3" /> New Template
            </button>
            <button onClick={onClose} className="p-1.5 hover:bg-gray-100 rounded-lg">
              <X className="h-4 w-4 text-gray-400" />
            </button>
          </div>
        </div>
        <div className="flex-1 overflow-y-auto p-6">
          {loading ? (
            <div className="flex items-center justify-center py-8 text-gray-400"><Loader2 className="h-4 w-4 animate-spin mr-2" /> Loading...</div>
          ) : templates.length === 0 ? (
            <p className="text-center text-sm text-gray-400 py-8">No templates yet</p>
          ) : (
            <div className="space-y-2">
              {templates.map(t => (
                <div key={t.id} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg border border-gray-200 hover:border-gray-300 transition-colors"
                  data-testid={`tmgr-template-${t.id}`}>
                  <div className="flex items-center gap-3 min-w-0">
                    <div className={`h-8 w-8 rounded-lg flex items-center justify-center flex-shrink-0 ${t.is_builtin ? 'bg-[#0A1F44]' : 'bg-[#D4AF37]'}`}>
                      <Mail className={`h-4 w-4 ${t.is_builtin ? 'text-[#D4AF37]' : 'text-[#0A1F44]'}`} />
                    </div>
                    <div className="min-w-0">
                      <div className="flex items-center gap-2">
                        <span className="text-sm font-medium text-[#0A1F44] truncate">{t.name}</span>
                        {t.is_builtin && <span className="px-1.5 py-0.5 bg-gray-200 text-gray-600 text-[9px] font-medium rounded flex-shrink-0">Built-in</span>}
                        {!t.is_builtin && <span className="px-1.5 py-0.5 bg-[#D4AF37]/20 text-[#0A1F44] text-[9px] font-medium rounded flex-shrink-0">Custom</span>}
                      </div>
                      <p className="text-[10px] text-gray-500 truncate">{t.description}</p>
                      <div className="flex gap-2 mt-0.5">
                        <span className="text-[10px] text-gray-400">{t.steps_count} steps</span>
                        <span className="text-[10px] text-gray-400">{t.total_days} days</span>
                      </div>
                    </div>
                  </div>
                  <div className="flex items-center gap-1 flex-shrink-0 ml-3">
                    <button onClick={() => onEdit(t.id)}
                      className="p-1.5 hover:bg-white rounded-lg transition-colors" title={t.is_builtin ? 'Customize' : 'Edit'}
                      data-testid={`edit-template-${t.id}`}>
                      <Edit3 className="h-3.5 w-3.5 text-gray-500" />
                    </button>
                    {t.is_builtin && (
                      <button onClick={() => onEdit(t.id)}
                        className="p-1.5 hover:bg-white rounded-lg transition-colors" title="Duplicate as custom">
                        <Copy className="h-3.5 w-3.5 text-gray-500" />
                      </button>
                    )}
                    {!t.is_builtin && (
                      <button onClick={() => onDelete(t.id)}
                        className="p-1.5 hover:bg-red-50 rounded-lg transition-colors" title="Delete"
                        data-testid={`delete-template-${t.id}`}>
                        <Trash2 className="h-3.5 w-3.5 text-red-400" />
                      </button>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
